import PropTypes from 'prop-types';
import React from 'react';
import useHandleNavClick from '../../hooks/useHandleNavClick';
import useTranslatedText from '../../hooks/useTranslatedText';
import CategoryNavigationList from '../CategoryNavigationList';
import { LOADING_MESSAGE } from '../Messages/Messages';
import useFetchLocalNavQuery from './hooks/useFetchLocalNavQuery';

const CategoryRailNavigation = ({
  categoryId,
  dispatch = () => {},
  enableXhrNav = false,
  isUnifiedCategoryPage = false,
  StoreToggle = null,
}) => {
  const {
    loading, error, categoryData,
  } = useFetchLocalNavQuery(categoryId);

  const navCategoriesLabel = useTranslatedText('navCategoriesLabel', { fallback: 'Categories' });

  const xhrNavClickHandler = useHandleNavClick(dispatch, 'navigation-left+nav');
  const handleClick = (event) => {
    if (event?.currentTarget?.dataset?.categoryId && isUnifiedCategoryPage && enableXhrNav) {
      event.preventDefault();
      xhrNavClickHandler(event);
    }
  };

  if (loading) {
    return LOADING_MESSAGE;
  }

  // Per team discussion, show nothing instead of error content/text in this case
  if (error || !categoryData?.localNavigation?.displayTypes) {
    return null;
  }

  const { localNavigation } = categoryData;
  return (
    <nav
      aria-label={navCategoriesLabel.value}
      className="mfe-rail-navigation mfe-category-rail-navigation"
    >
      {/* Category Navigation Heading */}
      {
      localNavigation.headingLabel ? (
        <h1
          className="mfe-rail-navigation__heading h2"
          data-aui={localNavigation.headingQaAttribute}
        >
          {
            // eslint-disable-next-line no-nested-ternary -- This nesting seems fine
            localNavigation.headingUrl
            && !localNavigation.headingScreenReaderOnly
              ? (
                <a
                  className="mfe-rail-navigation__heading-link"
                  data-category-id={localNavigation.rootCategoryId}
                  data-category-name={localNavigation.headingLabel}
                  href={localNavigation.headingUrl}
                  onClick={handleClick}
                >
                  {localNavigation.headingLabel}
                </a>
              )
              : (
                localNavigation.headingScreenReaderOnly
                  ? <div className="screen-reader-text">{localNavigation.headingLabel}</div>
                  : localNavigation.headingLabel
              )
          }
        </h1>
      ) : null
    }
      {/* Store Toggle Component */}
      {
        StoreToggle || <div className="store-toggle-container-target" />
      }
      {/* Category Navigation List */}
      <CategoryNavigationList
        handleClick={handleClick}
        localNavigation={localNavigation}
      />
    </nav>
  );
};

CategoryRailNavigation.propTypes = {
  categoryId: PropTypes.string.isRequired,
  enableXhrNav: PropTypes.bool,
  isUnifiedCategoryPage: PropTypes.bool,
  dispatch: PropTypes.func,
  StoreToggle: PropTypes.node,
};

export default CategoryRailNavigation;
